/* eslint-disable no-restricted-globals */
import parser from 'ua-parser-js';

const client = parser();

export const clientInfo = {
  Browser: client.browser.name,
  'Browser Version': client.browser.version,
  'Operating System': client.os.name,
  'Operating System Version': client.os.version,
  'Screen Width': screen && screen.width,
  'Screen Height': screen && screen.height,
  'Current URL': document && document.URL,
  Referrer: document && document.referrer,
  application: 'SSA',
};

export const platform = 'web';

export const clientInfoHeader = {
  'analytics-client-info': JSON.stringify({
    platform,
    ...clientInfo,
  }),
};
